import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { Accordion, AccordionDetails, AccordionSummary, Box, Link, Typography } from '@mui/material'
import React from 'react'
import type { AssetHolderSettlementDto } from '../../../../api/schema-dtos/SettlementDomainDtos'
import type { AssetHolderIdProps } from '../../pages/DashboardHome'
import PortfolioSettlementDetails from './PortfolioSettlementDetails'
import PortfolioSettlementForm from './PortfolioSettlementForm'
import ProjectSettlements from './ProjectSettlements'

export interface SettlementProps extends AssetHolderIdProps {
  settlement: AssetHolderSettlementDto
}
const ProjectSettlementListItem: React.FC<SettlementProps> = ({ assetHolderId, settlement }: SettlementProps) => {
  const accordionIdentifier = `dashboard-settlement-list-item-${assetHolderId}-${settlement.assetHolderSettlementId}`
  const openAccordion = settlement.state === 'PENDING'

  return (
    <>
      <Accordion sx={{ px: 4, pt: 2 }} defaultExpanded={openAccordion}>

        <AccordionSummary expandIcon={<ExpandMoreIcon color={'primary'}/>}
                          aria-controls={accordionIdentifier}
                          id={accordionIdentifier} sx={{ px: 0, pb: 2 }}>

          <Box sx={{ display: 'flex', width: '100%' }} justifyContent={'space-between'} alignItems={'center'} >
            <Typography variant={'h3'}>{settlement.settlementName}</Typography>
            <Box sx={{ mr: 2 }}>
              {/* <Box> */}
                {/* <Typography variant={'body2'} component={'span'}>Transfer date: </Typography> */}
                {/* <Typography variant={'body1'} component={'span'}>{settlement.transferDateFormatted}</Typography> */}
              {/* </Box> */}
              <Box>
                <Typography variant={'body2'} component={'span'}>Status: </Typography>
                <Typography variant={'body1'} component={'span'}>{settlement.state}</Typography>
              </Box>
            </Box>

          </Box>

        </AccordionSummary>

        <AccordionDetails >

          { (settlement.settlementName.includes('Jaltech') &&
            <Box sx={{ px: 0, pb: 4 }}>
              <Typography variant={'body1'}>
                As detailed in recent email communications, please find a list below of the solar projects you
                owned solar cells in that have now been sold to Jaltech, as well as your settlement amount for each one.
                Once you review the settlement details and confirm that you have read the indemnity notice, the settlement
                amounts will be allocated to your Sun Exchange wallet. Please check your email for more details. If you have
                not received an email with more information and next steps to retrieve your settlement, please
                contact us at <Link href={'mailto:hello@thesunexchange.com'}
                                    color={'primary.main'}
                                    underline={'hover'}
                                    variant={'body1'}
                                    sx={{}}>hello@thesunexchange.com</Link>
              </Typography>
            </Box>
          )}

          <Typography variant={'h3'} sx={{ mb: 2 }}>Settlement Details</Typography>
          {/* <Typography variant={'h4'} sx={{ mb: 2 }}>Status: {getSettlementApiResult.data.statusMessage}</Typography> */}

          <Box sx={{ mb: 4 }}>
            <PortfolioSettlementDetails settlementDto={settlement} />
          </Box>

          <Box sx={{ mb: 4 }}>
            <ProjectSettlements settlementDto={settlement}/>
          </Box>

          <PortfolioSettlementForm settlementDto={settlement}/>

        </AccordionDetails>

      </Accordion>

    </>

  )
}

export default ProjectSettlementListItem
